function cccAppValidate(requiredSections, errorMessage) {
    var isValid = typeof cccApp !== "undefined" && cccApp !== null;

    jQuery.each(requiredSections, function (index, value) {
            var obj = cccApp;
            var args = value.split(".");
            for (var i = 0; i < args.length; i++) {
                isValid = isValid && (obj && obj.hasOwnProperty(args[i]));
                if (!isValid) {
                    break;
                }
                obj = obj[args[i]];
                isValid = isValid && (typeof obj === "object");
            }
    });

    if (!isValid) {

        errorMessage = errorMessage || "Sorry, an error occurred.<br/>Please try again later.";

        cccAppUnavailable(errorMessage);

        try {
            logError("cccApp and/or required sections are unavailable", false, {
                "error": "cccApp or required sections (" + requiredSections + ") not present."
            });
        } catch (e) {
        }
    }

    return isValid;
}

function cccAppUnavailable(errorMessage, containerId) {

    errorMessage = errorMessage || "Sorry, an error occurred.<br/>Please try again later.";
    containerId = containerId || "main-content";

    var sectionContainer = document.getElementById(containerId);
    var messageContainer = document.getElementById("app-unavailable");
    var messagePlaceHolder = document.getElementById("app-unavailable-error-message");

    if (sectionContainer && messageContainer && messagePlaceHolder) {
        sectionContainer.className = "hide";
        messageContainer.className = "container tab-content app-unavailable pad";
        messagePlaceHolder.innerHTML = errorMessage;
    }

}

function initLibraries() {
    if (window.jQuery && window.ko && window.requirejs && window.moment && window.LE && $.fn.dropdown && $.featherlight) {
        if (cccAppValidate(["utils", "dates"])) {
            $("#main-content")
                .addClass("none")
                .css("visibility", "visible")
                .fadeIn(300, function() {
                     $(this).removeClass("none");
                });
        }
    } else {
        cccAppUnavailable();
    }
}

// Javascript Object prototype extensions

Number.prototype.pad = function (char, size) {
    var s = String(this);
    while (s.length < (size || 2)) { s = (char || " ") + s; }
    return s;
}